export class MemberModalService {
  static $inject = ['$modal'];

  constructor(private $modal) { }

  addMember(member) {
    const modalInstance = this.$modal.open({
      animation: true,
      template:
        '<add-member-modal modal-instance="modalInstance" member="member"></add-member-modal>',
      controller: [
        '$scope',
        '$modalInstance',
        'member',
        function ($scope, $modalInstance, member) {
          $scope.modalInstance = $modalInstance;
          $scope.member = member;
        },
      ],
      resolve: {
        member: () => member,
      },
    });

    return modalInstance.result;
  }
}
